import { render, staticRenderFns } from "./TerraformInventoryForm.vue?vue&type=template&id=c70cd648"
import script from "./TerraformInventoryForm.vue?vue&type=script&lang=js"
export * from "./TerraformInventoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports